import React from 'react';
import { useRouter } from "next/router";
import { IChatUserDto } from '@/Models/Chat';
import { StyledChatHeader } from './ChatHeader.style';
import Image from '@/Components/atoms/Image';
import { getImageUrlByPath } from '@/Services/Image';
import { useTranslation } from 'next-i18next';
import ChatHeaderSkeleton from './ChatHeaderSkeleton';
import { IconButton } from '@mui/material';
import CommonSvg, { svgNames } from '@/Components/atoms/CommonSvg';
import { useIsMobile } from '@/Hooks/useIsMobile';

type Props = {
  data: IChatUserDto;
  loading: boolean;
}

const ChatHeader = ({ data, loading }: Props) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const router = useRouter();

  const goBack = () => {
    router.back();
  }

  if(!data || loading) {
    return <ChatHeaderSkeleton />;
  }

  return (
    <StyledChatHeader className='chat-header'>
      { isMobile && (
        <IconButton onClick={goBack} disableRipple sx={{ height: '35px', borderRadius: 2, color: 'gray.main', padding: 0 }}>
          <CommonSvg name={svgNames.ArrowLeft} />
        </IconButton>
      )}
      <div className='chat-header__user-img-wrapper'>
        {
          data.avatarPath
          ? <Image src={ getImageUrlByPath(data.avatarPath, 80, 80) } alt='' />
          : <span>{ data.name.slice(0, 1) }</span>
        }
      </div>
      <div className='chat-header__text-wrapper'>
        <h5 className='chat-header__title'>{ data.name }</h5>
        <p className='chat-header__description'>{ t('archived_chat_product_title', { key: data.productTitle }) }</p>
      </div>
      { data.imagePath &&
        <div className='chat-header__product-img-wrapper'>
          <Image src={ getImageUrlByPath(data.imagePath, 80, 80) } alt='' />
        </div>
      }
    </StyledChatHeader>
  )
}

export default ChatHeader;
